import React from "react";
import { useAppSelector } from "@app/state";
// import { selectCurrentShowCaseTreeList } from "@app/state";
import { selectShowCardForm } from "@app/state";
import { useReverseRoute, useWindowDimensions } from "@app/contexts";
import { ShowCaseTreeList, PeriodPicker } from "@app/components";
import Button from "devextreme-react/button";
import ScrollView from "devextreme-react/scroll-view";
import { Switch, Case, CaseElse } from "@app/contexts";

import type { TDBRunShowCase, TParamDefinitionValues } from "@app/types";
import "./showcase.scss";

export const ShowCase = () => {
  const { routeInit } = useReverseRoute("profile");
  const { drawerHeight } = useWindowDimensions();
  const theSelectedShowCardForm = useAppSelector(selectShowCardForm);
  return (
    <div
      ref={routeInit}
      className="profile-page"
      style={{ "--drawerHeight": `${drawerHeight}px` } as React.CSSProperties}
    >
      <div className="profile-treelist">
        <ShowCaseTreeList />
      </div>
      <div className="profile-content-showcase">
        <ScrollView>
          <div className={"dx-announce"}>
            <p>
              Diverse liste pe baza carora se pot genera rapoarte. Unele sunt
              deja incluse in Jurnal Gold, altele sunt doar studii sau
              experimente. <br />
            </p>
          </div>
          <div className="dx-card-wrapper">
            {theSelectedShowCardForm.map((dt: TDBRunShowCase, i) => (
              <div className={"dx-card showcase"} key={i}>
                <div className="dx-card-header">
                  <span>
                    <i className={`dx-icon dx-icon-${dt.ICON}`}>
                      <div className="dx-cs-id">
                        {"#"}
                        {dt.SC_ID}
                      </div>
                    </i>
                  </span>
                  <div className="dx-card-title">{dt.TITLE_RO}</div>
                  <div className={"break"} />
                  <div className="dx-card-subtitle">{dt.SUBTITLE}</div>
                </div>
                <div className="dx-card-content">
                  <div id={"notes-fieldset"} className="dx-fieldset">
                    <div className="dx-field">
                      <div className={"dx-field-label"}>{"Desc:"}</div>
                      <div className={"dx-field-value-static"}>
                        {dt.DESCRIPTION}
                      </div>
                    </div>
                    <div className="dx-field">
                      <div className={"dx-field-label"}>{"Cat:"}</div>
                      <div className={"dx-field-value-static"}>
                        {dt.SC_GROUPS}
                      </div>
                    </div>
                    <div className="dx-field">
                      <div className={"dx-field-label"}>{"Upd:"}</div>
                      <div className={"dx-field-value-static"}>
                        {new Date(
                          dt.UPDATED || dt.CREATED
                        ).toLocaleDateString()}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="dx-card-params">
                  <Switch value={dt?.selectionOptions?.PERIOD_PICKER}>
                    <Case when={[(x: string) => x]}>
                      <PeriodPicker
                        showCase={dt.SC_UUID}
                        pickerType={
                          dt?.selectionOptions
                            ?.PERIOD_PICKER as TParamDefinitionValues
                        }
                      />
                    </Case>
                    <CaseElse>
                      <div className="dx-card-note">{"(fara param)"}</div>
                    </CaseElse>
                  </Switch>
                </div>
                <div className="dx-card-footer">
                  <Button
                    text="Vizualizare"
                    onClick={() => {
                      const urlParams = new URLSearchParams({
                        page: dt.SC_UUID,
                        ...dt.runtimeParams,
                      });
                      if (process.env.NODE_ENV === "development") {
                        // window.open(`https:/admin.jurnalgold.ro/reports/?page=3e5fa10c-8623-40f1-a7ec-66c1ffefc53a`, 'showcase','');
                        window.open(
                          `http://localhost:3001/?${urlParams.toString()}`,
                          "showcase",
                          ""
                        );
                      } else {
                        window.open(
                          `/reports/?${urlParams.toString()}`,
                          "showcase",
                          ""
                        );
                      }
                    }}
                  />
                </div>
              </div>
            ))}
          </div>
        </ScrollView>
      </div>
    </div>
  );
};
